//#region Imports

import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Crud } from '../../shared/services/crud/crud';
import { UserPayload } from '../../shared/types/payloads/user.payload';
import { MeService } from '../../shared/services/me/me.service';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CrudContainerComponent } from '../../shared/components/crud-container/crud-container.component';
import { InputComponent } from '../../shared/components/input/input.component';
import { ListHeaderComponent } from '../../shared/components/list-header/list-header.component';
import { TooltipModule } from 'primeng/tooltip';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';
import { SpinnerColorEnum } from '../../shared/components/spinner/types/spinner-color.enum';
import { SpinnerSizeEnum } from '../../shared/components/spinner/types/spinner-size.enum';
import { ToastService } from '../../shared/components/toast/service/toast.service';
import { getCrudErrorMessage } from '../../shared/utils/functions';

//#endregion

interface UserForm {
  name: FormControl<string>;
  email: FormControl<string>;
  password: FormControl<string>;
}

@Component({
    selector: 'l-profile',
    templateUrl: './profile.component.html',
    imports: [
        ButtonComponent,
        CrudContainerComponent,
        FormsModule,
        InputComponent,
        ListHeaderComponent,
        ReactiveFormsModule,
        SpinnerComponent,
        TooltipModule,
    ]
})
export class ProfileComponent extends Crud<UserForm> {

  constructor(
    private readonly meService: MeService,
    private readonly toastService: ToastService,
  ) {
    super();
  }

  public isSubmitting = false;

  public readonly spinnerColorEnum = SpinnerColorEnum;

  public readonly spinnerSizeEnum = SpinnerSizeEnum;

  public override form = new FormGroup<UserForm>(<UserForm>{
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
  });

  public override mapField = {
    name: 'name',
    email: 'email',
  };

  public override async initialize(): Promise<void> {
    if (!this.isUpdate || !this.id)
      return;

    const user = this.meService.me();

    if (!user)
      return;

    this.form.patchValue({
      name: user.name,
      email: user.email,
    });
  }

  public async submit(): Promise<void> {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    try {
      const payload = this.form.getRawValue() as UserPayload;
      await this.meService.updateProfile({
        ...payload,
        imageUrl: payload.imageUrl ?? this.meService.me()?.imageUrl,
      });
      this.toastService.success('Perfil atualizado com sucesso.');
    } catch (error) {
      this.toastService.error(getCrudErrorMessage(error), 'Oops...');
    } finally {
      this.isSubmitting = false;
    }
  }

}
